<template>
    <div class="faq-editor">
      <h3>Éditeur de marge sur les taux</h3>
      <b-table striped hover :items="items"></b-table>
      <table>
        <thead>
          <tr>
            <th scope="col">Devise</th>
            <th scope="col">Marge Achat</th>
            <th scope="col">Marge Vente</th>
          </tr>
        </thead>
        <tr v-for="(faq, index) in localfieldData.currenciesItems" :key="index" class="faq-item">
          <td>{{ index }}</td>
          <td><input type="checkbox" v-model="localfieldData.currenciesItems[index].home"></td>
          <td><input type="checkbox" v-model="localfieldData.currenciesItems[index].principale"></td>
          <td><input type="checkbox" v-model="localfieldData.currenciesItems[index].autre"></td>
        </tr>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name: "currenciesEditor",
    props: {
      fieldData: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        // Crée une copie locale de fieldData
        localfieldData: JSON.parse(JSON.stringify(this.fieldData)),
      };
    },
    methods: {
      addFaq() {
        this.localfieldData.push({
          question: "",
          answer: ""
        });
      },
      removeFaq(index) {
        this.localfieldData.splice(index, 1);
      },
      saveChanges() {
        // Émettre un événement pour envoyer les modifications au parent
        this.$emit("update-faq", this.localfieldData);
      }
    }
  };
  </script>
  
  <style scoped>
  .faq-editor {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .faq-item {
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  textarea {
    height: 100px;
  }
  
  button {
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-add {
    background-color: #28a745;
    color: white;
  }
  
  .btn-remove {
    background-color: #dc3545;
    color: white;
  }
  
  .btn-save {
    background-color: #007bff;
    color: white;
  }
  
  button:hover {
    opacity: 0.8;
  }
  </style>
  